import jurisdictionFromCountry from "cookiesConsent/domain/jurisdictionFromCountry"
import { JurisdictionRules } from "cookiesConsent/domain/jurisdiction"
import { currentGeo } from "cookiesConsent/infrastructure/edgeGeo/currentGeo"

export const currentJurisdiction = (): JurisdictionRules =>
  jurisdictionFromCountry(currentGeo().country)
